import { useState } from 'react';
import { goToServer, HOME_PATH } from '../server';
import { useDemoAccount } from './demoAccount';

/** Removed demos stay absent; restoring one always takes an explicit action. */
export function DemoAccountButton({ className }: { className?: string }) {
  const demo = useDemoAccount();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  if (demo.isPending || demo.isError) return null;
  return (
    <>
      <button
        type="button"
        className={className}
        disabled={busy}
        onClick={async () => {
          setBusy(true);
          setError('');
          try {
            if (demo.hidden) await demo.setHidden(false);
            goToServer('demo', HOME_PATH);
          } catch {
            setError('Couldn’t restore the demo. Please try again.');
            setBusy(false);
          }
        }}
      >
        {demo.hidden ? 'Restore demo account' : 'Explore Demo: Juniper Home Goods'}
      </button>
      {error ? <p role="alert">{error}</p> : null}
    </>
  );
}
